export class SeniorManagersHistoryDetails {

  ID: number;
  EmpCode: number;
  SeniorManagerCode: number;
  SeniorManagerDesignationID: number;
  DesignationName: string;
  DurationFrom: Date;
  DurationTo: Date;
  CreatedBy: string;
  CreatedDate: Date;
  UpdatedBy: string;
  UpdatedDate: Date;
  IsActive: boolean;
  //Added to display seniormanger name along with code
  smDisplayName: string;
  //to display error message for duplicate records in history tab
  hasDuplicateNameError?: boolean;
  duplicateNameMessage?: string;
  InvalidName?: boolean;
}
